// Sesion del empleado en sessionStorage: se pierde al cerrar la pestania,
// que es lo correcto para una app que puede usarse en una PC compartida.
// No hay JWT: el backend identifica al empleado por codigoLegajo (legajo en Base64).
const CLAVE = "sesion";

export class SesionService {
  static iniciar({ codigoLegajo, nombre, diasDisponibles, fotoVersion = null }) {
    const empleado = {
      codigoLegajo,
      // El codigo es el legajo en Base64 (Helpers/CriptoBase64.cs); el numero se usa
      // para armar el codigo de solicitud de un pedido urgente.
      legajo: Number.parseInt(atob(codigoLegajo)) || 0,
      nombre,
      diasDisponibles: Number.parseInt(diasDisponibles) || 0,
      // null = sin foto de perfil; cambia con cada subida (cache-busting)
      fotoVersion: fotoVersion ?? null,
    };
    sessionStorage.setItem(CLAVE, JSON.stringify(empleado));
    return empleado;
  }

  /** Empleado logueado o null. */
  static empleado() {
    try {
      const raw = sessionStorage.getItem(CLAVE);
      if (!raw) return null;
      const emp = JSON.parse(raw);
      if (!emp?.codigoLegajo) return null;
      // Sesiones iniciadas antes de que se guardara el legajo numerico: se completa al vuelo
      if (!emp.legajo) {
        emp.legajo = Number.parseInt(atob(emp.codigoLegajo)) || 0;
        sessionStorage.setItem(CLAVE, JSON.stringify(emp));
      }
      return emp;
    } catch {
      return null;
    }
  }

  /** Refresca los dias disponibles (RRHH puede liquidar mientras la sesion esta abierta). */
  static actualizarDias(diasDisponibles) {
    const emp = this.empleado();
    if (!emp) return;
    emp.diasDisponibles = Number.parseInt(diasDisponibles) || 0;
    sessionStorage.setItem(CLAVE, JSON.stringify(emp));
  }

  static actualizarFoto(fotoVersion) {
    const emp = this.empleado();
    if (!emp) return;
    emp.fotoVersion = fotoVersion ?? null;
    sessionStorage.setItem(CLAVE, JSON.stringify(emp));
  }

  static cerrar() {
    sessionStorage.removeItem(CLAVE);
  }
}
